<!-- 考阅大数据 -->
<template>
  <div class="examine-big-data">
    <div class="examine-big-data-title">
      <div class="name">考阅大数据</div>
      <div class="more">详情<i class="el-icon-arrow-right"></i></div>
    </div>
    <div class="examine-big-data-table">
      <el-row type="flex" class="top">
        <el-col span="16">学校名称</el-col>
        <el-col span="8">举办次数</el-col>
      </el-row>
      <el-row type="flex" class="content" v-for="item,index in schoolList" :key="index">
        <el-col span="16">{{ item.name }}</el-col>
        <el-col span="8">{{ item.number }}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'examine-big-data',
  components: {
  },
  data() {
      return {
        schoolList:[
        {
          name:'徐沟镇中学',
          number:98
        },{
          name:"柳杜乡小学",
          number:75
        },{
          name:"西城小学",
          number:66
        },{
          name:"南城小学",
          number:3
        },{
          name:"东城小学",
          number:4
        }
        ]
      }
  },
  methods: {

  },
  mounted(){

  },
}
</script>
<style lang="scss" scoped>
.examine-big-data{
  width: 100%;
  margin-top: 20px;
  .examine-big-data-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    height: 40px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .examine-big-data-table{
    width: 100%;
    height: auto;
    padding: 0 13px;
    background: rgba(9,19,66,0.82);
    .top{
      padding: 0 13px;
      height: 42px;
    }
    .content{
      padding: 0 13px;
      height: 48px;
      border: 1px solid #14326C;
    }
  }
}
</style>
<style lang="scss">
  .examine-big-data-table{
    .top,
    .content{
      .el-col{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
    }
  }
</style>